import { TextField, TextFieldProps } from "@mui/material";
import { FieldError, useFormContext } from "react-hook-form";

type FormFieldProps = {
  name: string;
  error?: FieldError;
} & Omit<TextFieldProps, "variant" | "error" | "name">;

export const TextFormField = ({
  type,
  label,
  name,
  error,
  ...rest
}: FormFieldProps) => {
  const formContext = useFormContext();
  const { register, clearErrors, watch } = formContext;
  const registration = register(name);
  const value = watch(name);
  const hasValue = !!value && value.toString().trim() !== "";

  return (
    <TextField
      id={name}
      type={type}
      label={label}
      variant="outlined"
      {...registration}
      value={value || ""}
      InputLabelProps={{
        shrink: hasValue || undefined,
        sx: {
          ...(hasValue && {
            position: "absolute",
            transform: "translate(14px, -9px) scale(0.75)",
            transformOrigin: "top left",
            backgroundColor: "background.paper",
            padding: "0 4px",
            zIndex: 1,
          }),
        },
      }}
      onChange={(e) => {
        // Call the original onChange handler
        registration.onChange(e);
        // Clear error when user starts typing
        clearErrors(name);
      }}
      error={!!error}
      helperText={error?.message}
      {...rest}
    />
  );
};
